import React from "react";
import { Form, Input } from "antd";
//
//component
//redux
//selector
//actions
//utils
//hook
//str
const FormInput = (props) => {
  // -------------------------- VAR -----------------------------
  const label = props.label;
  const name = props.name || "Tên";
  const placeholder = props.placeholder || "Nhập Tiêu đề";
  const className = props?.className || "";
  const rules = props?.rules || [];
  const prefix = props?.prefix || null;
  const suffix = props?.suffix || null;
  const hidden = props?.hidden || false;
  const style = props?.style || {};
  const initialValue = props?.initialValue;
  const disabled = props?.disabled || false;
  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------
  // -------------------------- FUNCTION ------------------------
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN ----------------------------
  return (
    <Form.Item
      name={name}
      label={label}
      rules={rules}
      hidden={hidden}
      className={className}
      initialValue={initialValue}
    >
      <Input
        style={style}
        prefix={prefix}
        suffix={suffix}
        placeholder={placeholder}
        disabled={disabled}
      />
    </Form.Item>
  );
};
export default FormInput;
